import { isOfType } from '../../../../ts-utils';
import { getMessageFromError } from '../comments-errors';
import { showToast } from '../effects/show-toast-action';
export const REPORT_COMMENT_SUCCESS = 'REPORT_COMMENT_SUCCESS';
export const REPORT_COMMENT_FAILURE = 'REPORT_COMMENT_FAILURE';
export const reportCommentSuccess = (payload) => ({
    type: REPORT_COMMENT_SUCCESS,
    payload,
});
export const reportCommentFailure = (payload) => ({
    type: REPORT_COMMENT_FAILURE,
    payload,
});
export const reportComment = ({ resourceId, commentId, isReply = false, }) => async (dispatch, getState, { commentsService }) => {
    const resourceState = getState().comments[resourceId];
    if (resourceState?.type !== 'READY') {
        return;
    }
    const result = await commentsService.reportComment({
        commentId,
    });
    if (result.type === 'SUCCESS') {
        dispatch(reportCommentSuccess({ resourceId, commentId }));
        dispatch(showToast({
            resourceId,
            skin: 'success',
            message: {
                type: 'TRANSLATION',
                key: isReply ? 'toast.report-reply-success' : 'toast.report-comment-success',
            },
        }));
    }
    else {
        dispatch(reportCommentFailure({ resourceId, commentId }));
        const message = getMessageFromError(result.error);
        if (message.type === 'TOAST') {
            dispatch(showToast({
                resourceId,
                skin: 'error',
                message: message.message,
            }));
        }
    }
};
export const isReportCommentAction = isOfType([REPORT_COMMENT_SUCCESS, REPORT_COMMENT_FAILURE]);
//# sourceMappingURL=report-actions.js.map